import { termsPolicyAndContactConstants } from "../constants/termsPolicyAndContactConstants";
import { termsPolicyAndContactService } from "../../services/API/termsPolicyAndContactService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";

export const add_static_page = postData => {
  return dispatch => {
    dispatch(request());
    termsPolicyAndContactService.add_static_page(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return {
      type: termsPolicyAndContactConstants.ADD_STATIC_PAGE_REQUEST,
      data
    };
  }
  function success(data) {
    return {
      type: termsPolicyAndContactConstants.ADD_STATIC_PAGE_SUCCESS,
      data
    };
  }
  function failure(error) {
    return {
      type: termsPolicyAndContactConstants.ADD_STATIC_PAGE_FAILURE,
      error
    };
  }
};

export const get_becomePartner_details = postData => {
  return dispatch => {
    dispatch(request());
    termsPolicyAndContactService.get_becomeapartner_details(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return {
      type: termsPolicyAndContactConstants.GET_BECOMEAPARTNER_REQUEST,
      data
    };
  }
  function success(data) {
    return {
      type: termsPolicyAndContactConstants.GET_BECOMEAPARTNER_SUCCESS,
      data
    };
  }
  function failure(error) {
    return {
      type: termsPolicyAndContactConstants.GET_BECOMEAPARTNER_FAILURE,
      error
    };
  }
};

export const get_static_page_list = formData => {
  return dispatch => {
    dispatch(request());
    termsPolicyAndContactService.get_static_page_list(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return {
      type: termsPolicyAndContactConstants.GET_STATIC_PAGE_REQUEST,
      data
    };
  }
  function success(data) {
    return {
      type: termsPolicyAndContactConstants.GET_STATIC_PAGE_SUCCESS,
      data
    };
  }
  function failure(error) {
    return {
      type: termsPolicyAndContactConstants.GET_STATIC_PAGE_FAILURE,
      error
    };
  }
};

export const get_static_page_details = () => {
  return dispatch => {
    dispatch(request());
    termsPolicyAndContactService.get_static_page_details().then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return {
      type: termsPolicyAndContactConstants.GET_STATIC_PAGE_DETAILS_REQUEST,
      data
    };
  }
  function success(data) {
    return {
      type: termsPolicyAndContactConstants.GET_STATIC_PAGE_DETAILS_SUCCESS,
      data
    };
  }
  function failure(error) {
    return {
      type: termsPolicyAndContactConstants.GET_STATIC_PAGE_DETAILS_FAILURE,
      error
    };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/termsPolicyAndContactActions.js